
<div class="page">

    <div class="page-header">
        <div class="breadcrumb">
            <p-breadcrumb [model]="breadcrumbs" [home]="homeBreadcrumb"></p-breadcrumb>
        </div>
        <div class="search">
            <input pInputText type="text" (input)="filter(dt, $event)" placeholder="Search..." />           
        </div>
        <div class="actions">
            <button pButton pRipple label="New" icon="pi pi-plus" class="button-action p-button-success p-mr-2" [routerLink]="['/movement/moves']"></button>
            <button pButton pRipple label="Delete" icon="pi pi-trash" class="button-action p-button-danger" (click)="deleteSelectedMovements()" [disabled]="!selectedMovements || !selectedMovements.length "></button>
        </div> 
    </div>

    <div class="page-content">
        <p-table #dt 
            [value]="movements" 
            [rows]="10" 
            [paginator]="true" 
            
            [globalFilterFields]="['name','when','who','fromWhat.0.name','fromWhat.0.batch','why','isEnabled','fromWhat.1.name','fromWhat.1.batch','fromWhat.2.name','fromWhat.2.batch','fromWhat.3.name','fromWhat.3.batch','fromWhat.4.name','fromWhat.4.batch', 'toWhat.name' ,'toWhat.batch']"

            [rowsPerPageOptions]="[5,10,25,50,100]"
            [(selection)]="selectedMovements" 
            [resizableColumns]="true"
            [reorderableColumns]="true"
            [rowHover]="true" 
            dataKey="$key"
            styleClass="p-datatable-striped"
            currentPageReportTemplate="{first} to {last} of {totalRecords}" 
            [showCurrentPageReport]="true"
            selectionMode="multiple"
            [columns]="selectedColumns"
            >

            <ng-template pTemplate="colgroup">
                <colgroup>
                    <col style="max-width:10%">
                    <col style="max-width:20%">
                    <col style="min-width:10%;max-width:80%">
                    <col style="max-width:20%">
                </colgroup>
            </ng-template>
            
            <ng-template pTemplate="caption">
                <p-multiSelect [options]="cols" [(ngModel)]="selectedColumns" optionLabel="header"
                selectedItemsLabel="{0} columns selected" [style]="{minWidth: '200px'}" placeholder="Choose Columns"></p-multiSelect>
            </ng-template>


            <ng-template pTemplate="header" let-columns="columns">
                <tr>
                    <th pResizableColumn pSortableColumn="position" style="width: 8rem">
                        Order<p-sortIcon field="position"></p-sortIcon>
                    </th>
                    <th id="instant" name="instant" pResizableColumn pReorderableColumn pSortableColumn="instant" [class]="includesCol('instant') ? 'd' : 'h'">Date Time 
                        <p-sortIcon field="instant"></p-sortIcon> 
                        <p-columnFilter type="text" field="instant" display="menu"></p-columnFilter>
                    </th>

                    <th id="user" name="user" pResizableColumn pReorderableColumn pSortableColumn="user" [class]="includesCol('user') ? 'd' : 'h'">User 
                        <p-sortIcon field="user"></p-sortIcon> 
                        <p-columnFilter type="text" field="user" display="menu"></p-columnFilter>
                    </th>


                    <th id="products" name="products" pResizableColumn pReorderableColumn pSortableColumn="products" [class]="includesCol('products') ? 'd' : 'h'">Products
                        <p-sortIcon field="products"></p-sortIcon> 
                        <p-columnFilter type="text" field="products" display="menu"></p-columnFilter>
                    </th>

                    <th id="fromLocation" name="fromLocation" pResizableColumn pReorderableColumn pSortableColumn="fromLocation" [class]="includesCol('fromLocation') ? 'd' : 'h'">From
                        <p-sortIcon field="fromLocation"></p-sortIcon> 
                        <p-columnFilter type="text" field="fromLocation" display="menu"></p-columnFilter>
                    </th>

                    <th id="toLocation" name="toLocation" pResizableColumn pReorderableColumn pSortableColumn="toLocation" [class]="includesCol('toLocation') ? 'd' : 'h'">To
                        <p-sortIcon field="toLocation"></p-sortIcon> 
                        <p-columnFilter type="text" field="toLocation" display="menu"></p-columnFilter>
                    </th>

                    <th pResizableColumn pReorderableColumn style="width: 8rem; vertical-align: middle;">
                        <div class="actions-th">
                            <span>Actions</span> 
                            <p-tableHeaderCheckbox style="float: right;margin-right:3px" class="checkbox"></p-tableHeaderCheckbox>
                        </div>
                    </th>
                    
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-movement let-columns="columns" let-index="rowIndex">
                <tr [pReorderableRow]="index" >
                    <td pEditableColumn>
                        <span class="pi pi-bars" [pReorderableRowHandle]="index"></span>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="movement.position" required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{movement.position}} {{index}}
                            </ng-template>
                        </p-cellEditor>
                        <!-- <p-tableCheckbox [value]="movement"></p-tableCheckbox> -->
                    </td>

                    <td pEditableColumn [class]="includesCol('instant') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="movement.name" (blur)="completeMovement(movement)" (keydown.tab)="completeMovement(movement)" (keydown.enter)="completeMovement(movement)"  required>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{movement.instant}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('user') ? 'd' : 'h'">
                        <p-cellEditor >
                            <ng-template pTemplate="input">
                                <p-dropdown 
                                    appendTo="body" 
                                    [filter]="true"
                                    [showClear]="false" 
                                    [(ngModel)]="dialogSelectContentKey" 
                                    [options]="contentTypes" 
                                    optionLabel="name" 
                                    optionValue="$key"
                                    (blur)="completeMovement(movement)"
                                    (keydown.tab)="completeMovement(movement)"
                                    (keydown.enter)="completeMovement(movement)"
                                    placeholder="Any">
                                </p-dropdown>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{movement.userEmail}}</span>
                                <span >{{movement.who}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('products') ? 'd' : 'h'">
                        <p-cellEditor >
                            <ng-template pTemplate="input">
                               
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <!-- <span >{{movement.fromLocation }}</span> -->
                                <div style="margin-top: 1px;margin-bottom: 1px;" *ngFor="let loc of fromLocations(movement)">
                                    <p-tag styleClass="mr-2" >
                                        {{ loc.name }} - {{ loc.batch }}
                                    </p-tag>
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('fromLocation') ? 'd' : 'h'">
                        <p-cellEditor >
                            <ng-template pTemplate="input">
                               
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <!-- <span >{{movement.fromLocation }}</span> -->
                                <div style="margin-top: 1px;margin-bottom: 1px;"  *ngFor="let loc of fromLocations(movement)">
                
                                    <p-tag styleClass="mr-2" >
                                        {{ loc.location }}
                                    </p-tag>
                                    
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('toLocation') ? 'd' : 'h'">
                        <p-cellEditor >
                            <ng-template pTemplate="input">
                                <p-dropdown 
                                    appendTo="body" 
                                    [filter]="true"
                                    [showClear]="false" 
                                    [(ngModel)]="dialogSelectPackagingKey" 
                                    [options]="packagingTypes" 
                                    optionLabel="name" 
                                    optionValue="$key"
                                    (blur)="completeMovement(movement)"
                                    (keydown.tab)="completeMovement(movement)"
                                    (keydown.enter)="completeMovement(movement)"
                                    placeholder="Any">
                                </p-dropdown>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <!-- <span >{{movement.toLocation }}</span> -->
                                <div style="margin-top: 1px;margin-bottom: 1px;"  *ngFor="let loc of toLocations(movement)">
                                    
                                    <p-tag styleClass="mr-2" >
                                        {{ loc.location }}
                                    </p-tag>
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <!-- <td pEditableColumn [class]="includesCol('isEnabled') ? 'd' : 'h'" class="enabled" style="text-align: center;">
                        <p-inputSwitch  [(ngModel)]="movement.isEnabled" (onChange)="completeMovement(movement)"></p-inputSwitch>
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="text" [(ngModel)]="movement.isEnabled"  (blur)="completeMovement(movement)" (keydown.tab)="completeMovement(movement)" (keydown.enter)="completeMovement(movement)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{movement.isEnabled}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td> -->


                    <!-- <td>{{movement.name}}</td> -->
                    <!-- <td>nicolas</td> -->
                    <!-- <td><img [src]="'assets/showcase/images/demo/product/' + product.image" [alt]="product.name" width="100" class="p-shadow-4" /></td> -->
                    <!-- <td>{{product.price | currency:'USD'}}</td>
                    <td>{{product.category}}</td>
                    <td><p-rating [ngModel]="product.rating" [readonly]="true" [cancel]="false"></p-rating></td>
                    <td><span [class]="'product-badge status-' + (product.inventoryStatus ? product.inventoryStatus.toLowerCase() : '')">{{product.inventoryStatus}}</span></td> -->
                    <td class="row-actions">
                        <button pButton style="margin-right: 10px"  pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" (click)="editMovement(movement)"></button>
                        <button pButton style="margin-right: 10px"  pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteMovement(movement)"></button>
                        <p-tableCheckbox class="checkbox" [value]="movement"></p-tableCheckbox>
                        
                    </td>
                    <!-- <td>
                        <p-tableCheckbox [value]="movement"></p-tableCheckbox>
                    </td> -->
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="summary">
                    <div class="summary-total">
                        Total: {{movements ? movements.length : 0 }} movements.
                    </div>
                    <div class="summary-export">
                        <button type="button" style="margin-right: 10px" pButton pRipple icon="pi pi-file-o" (click)="exportToCsv()" class="p-mr-2" pTooltip="CSV" tooltipPosition="bottom"></button>
                        <button type="button" style="margin-right: 10px" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2"  pTooltip="XLS" tooltipPosition="bottom"></button>
                        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
                    </div>
                </div>
            </ng-template>
        </p-table>

    </div>

    <div class="page-footer">
       
        <div class="p-d-flex">
            <!-- <button type="button" pButton pRipple icon="pi pi-filter" (click)="dt.exportCSV({selectionOnly:true})" class="p-button-info p-ml-auto" pTooltip="Selection Only" tooltipPosition="bottom"></button> -->
        </div>
            
    </div>
    
    <p-dialog [(visible)]="movementDialog" [style]="{width: '450px', height: '450px'}" header="Packaging Type Details" [modal]="true" styleClass="p-fluid" [baseZIndex]='1000'>
        <!-- <ng-template > -->
            <!-- <img [src]="'assets/showcase/images/demo/product/' + product.image" [alt]="product.image" class="product-image" *ngIf="product.image"> -->
            <div class="p-field">
                <label for="name">Name</label>
                <input type="text" pInputText id="name" [(ngModel)]="movement.when" required autofocus />
                <small class="p-error" *ngIf="submitted && !movement.when">Name is required.</small>
            </div>


            <div >
                <label for="content" style="margin-left: 20px;margin-right: 10px;">Content</label>
                <p-dropdown 
            
                    appendTo="body" 
                    [filter]="true"
                    [showClear]="false" 
                    [(ngModel)]="dialogSelectContentKey" 
                    [options]="contentTypes" 
                    optionLabel="name" 
                    optionValue="$key"
                    placeholder="Any">
                </p-dropdown>
            </div>

            <div >
                <label for="container" style="margin-left: 20px;margin-right: 10px;">Packaging</label>
                <p-dropdown 
          
                    appendTo="body" 
                    [filter]="true"
                    [showClear]="false" 
                    [(ngModel)]="dialogSelectPackagingKey" 
                    [options]="packagingTypes" 
                    optionLabel="name" 
                    optionValue="$key"
                    placeholder="Any">
                </p-dropdown>
            </div>
                   

        <!-- https://dev.to/idrisrampurawala/exporting-data-to-excel-and-csv-in-angular-3643 -->
        
        <!-- <ng-template pTemplate="footer"> -->
            <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
            <button pButton pRipple label="Save" icon="pi pi-check" class="p-button-text" (click)="saveMovement()"></button>
        <!-- </ng-template> -->
    </p-dialog>
    
    <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

</div>







